import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material"
import { useState } from "react"

type LogoutConfirmDialogProps = {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export const LogoutConfirmDialog = ({
  open,
  onConfirm,
  onCancel,
}: LogoutConfirmDialogProps) => {
    return (
        <Dialog 
            open={open}
            onClose={onCancel}>
            <DialogTitle>Confirm Logout</DialogTitle>
            <DialogContent>
                Are you sure you want to logout?
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel}>Cancel</Button>
                <Button
                    color="error"
                    onClick={onConfirm}
                >
                    Logout
                </Button>
            </DialogActions>
        </Dialog>
    )
}